/**
 * PontaSla
 * @author Gil
 */
import {ID, Model, ResponseSerialize} from 'simpli-web-sdk'

export default class PontaSla extends Model {
  readonly $name: string = 'PontaSla'

  idPontaSlaPk: ID = 0
  abreviacao: string | null = null
  uf: string | null = null
  naCapital = false

  get $id() {
    return this.idPontaSlaPk
  }

  set $id(val: ID) {
    this.idPontaSlaPk = val
  }

  get $tag() {
    return `${this.abreviacao} - ${this.naCapital ? 'Capital' : 'Interior'}`
  }
}
